import React, { useEffect, useState } from "react";

import { CompanyTitledPage } from "../../TitledPage";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Paper from "@mui/material/Paper";
import Pagination from "@mui/material/Pagination"

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { grey } from '@mui/material/colors';

import { SYSTEM_PATH_COMPANY } from "../../../App";
import { getDisplaySize } from "../../../utils/Items";
import { sendFax } from "../../../features/fax/fax";
import { Button, Dialog, Typography } from "@mui/material";

import { MailPreviewWithoutMailTo } from "../../../components/MailPreview"
import PdfPreview from "../../../components/PdfPreview"
import { useLocation, useNavigate } from "react-router-dom";
import { getBasicPriceMailSubject, getBasicPriceMailText } from "../../../features/mail/mailTemplate";
import { sendMail } from "../../../features/mail/mail";
import ErrorMessageBox from "../../../components/ErrorMessageBox";
import DateInput from "../../../components/DateInput";
import { createBasePricePDF } from "../../../features/pdf/BasePricePDF";

import { postBasePriceSearchInfoListAPI } from "../../../http/api/BasePriceAPI";
import { postCustomerSendingGroupSearchInfoListAPI } from "../../../http/api/CustomerSendingGroupAPI";
import { postMarketCalendarSearchNextOpenDateInfoAPI } from "../../../http/api/MarketCalendarAPI";
import { MSG_ERR_SHIPPING_DATE_NOT_ENTERED, MSG_ERR_SHIPPING_DATE_NOT_FOUND } from "../../../common/message";
import { SelectDestinationSendingGroupDrawer } from "../../../components/drawers/SelectDestinationSendingGroupDrawer";

// 価格表の行の最大数
const maxPriceTableRows = 20

// 価格表カラム名
const priceTableColumnNames = {
  name: "商品", 
  place: "産地",
  size: "発注規格",
  price: "価格",
  unit: "発注単位"
}

const priceTableColumnSx = {
  fontSize: 18
}

// 基本価格表編集遷移state取得
const getBasicPriceEditLocationState = (shippingDate) => ({shippingDate});

// 価格表
function PriceTable(props) {

  const priceTableData = props.data

  var lastName = "";
  var lastOrigin = "";

  if (priceTableData && priceTableData.length > 0) {
    return (
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{...priceTableColumnSx, backgroundColor: grey[100]}}>{priceTableColumnNames.name}</TableCell>
              <TableCell sx={{...priceTableColumnSx, backgroundColor: grey[100]}}>{priceTableColumnNames.place}</TableCell>
              <TableCell sx={{...priceTableColumnSx, backgroundColor: grey[100]}}>{priceTableColumnNames.size}</TableCell>
              <TableCell sx={{...priceTableColumnSx, backgroundColor: grey[100]}}>{priceTableColumnNames.price}</TableCell>
              <TableCell sx={{...priceTableColumnSx, backgroundColor: grey[100]}}>{priceTableColumnNames.unit}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {priceTableData.map((data, i) => {
              
              var displayName = (lastName === data.productName) ? "" : data.productName;
              var displayOrigin = (lastName === data.productName && lastOrigin === data.origin) ? "" : data.origin;

              var displaySize = getDisplaySize(data.rank, data.productClass, data.weight, data.weightUnit, data.packing, data.quantity);

              lastName = data.productName
              lastOrigin = data.origin

              return(
                <TableRow key={i}>
                  <TableCell component="th" scope="row"  sx={{fontWeight: "bold", fontSize: 20, height: 28, width:"20%"}}>
                    {displayName}
                  </TableCell>
                  <TableCell sx={{...priceTableColumnSx, width: "10%"}}>{displayOrigin}</TableCell>
                  <TableCell sx={{...priceTableColumnSx, width: "30%"}}>{displaySize.length > 0 ? displaySize : "-"}</TableCell>
                  <TableCell sx={{...priceTableColumnSx, textAlign: "right", width: 100}}>{data.basePrice.toLocaleString()}</TableCell>
                  <TableCell sx={{...priceTableColumnSx}}>{data.orderingUnit}</TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }  
  
  return null;
}

// 価格表タブの内容
function PriceTableTabContent({dataList,tabPosition}) {

  const [page, setPage] = useState(1)

  const handleChangeTablePage = (event, page_num) => {
    setPage(page_num)
  }

  var dataMinIndex = (page - 1) * maxPriceTableRows

  var tableData = dataList.slice(dataMinIndex, Math.min(dataMinIndex + maxPriceTableRows, dataList.length))

  //タブを変更するイベント
  useEffect(() => {
    setPage(1);
    console.log("tab change");
    //TODO React18のバッチアップデートを除く
    setTimeout(() => {
      try {
        //ページ１をクリック
        let listPagingButton =
          document.getElementById(`paging`).children[0].children;
        listPagingButton[1].children[0].click();
      } catch {}
    }, 500);
  }, [tabPosition]);

  return (
    <Box>
      <Grid container spacing={2} marginBottom={2}>
        <Grid item xs={12}>
          <PriceTable data={tableData} />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{textAlign: 'center'}}>
          <Pagination
            count={Math.ceil(dataList.length / (maxPriceTableRows))}
            value={page} variant="outlined" shape="rounded"
            onChange={handleChangeTablePage}
            sx={{display: 'inline-block'}}
            id="paging"
          />
        </Grid>
      </Grid>     
    </Box>
  );
}

// メール送信Dialog
// props ...
//   open = ダイアログを開いていればtrue
//   onClose = ダイアログを閉じるときの処理 (event) => void
//   sendProps = 送信プロパティ
function SendMailDialog({open, onClose, sendProps}) {

  const [shops, setShops] = useState([]);

  const [customerSendingGroupInfoList, setCustomerSendingGroupInfoList] = useState([]);
  const [selectDestinationDrawerOpen, setSelectDestinationDrawerOpen] = useState(false)

  useEffect(() => {
    if (open) {
      setSelectDestinationDrawerOpen(false);
      setShops([]);

      (async () => {
        let selectInfoListRes = await postCustomerSendingGroupSearchInfoListAPI({});
        setCustomerSendingGroupInfoList(selectInfoListRes.customerSendingGroupInfoList);
      })();
    }
  }, [open])

  const today_dt = new Date();

  const officemanName = "○○"

  const mailSubject = getBasicPriceMailSubject(today_dt);
  const mailText = getBasicPriceMailText("[取引先店舗名]", officemanName, today_dt);

  // 上の内容でメール送信する　を押下時の挙動
  const onClickSendMailConfirm = async (event) => {

    let sendMailPropsList = getSelectedShopInfoList().map((shopInfo) => ({
      mailFrom : "",
      mailToList : [shopInfo.email],
      subject : mailSubject,
      text: getBasicPriceMailText(shopInfo.customerName + "　" + shopInfo.shopName, officemanName, today_dt),
      attachedFileInfoList: []
    }));

    try {
      await sendMail(sendMailPropsList);
      console.log(sendMailPropsList)
      alert("メールを送付しました。");
      onClose(event);
    } catch (err) {
        console.log(err);
        alert("メールの送付に失敗しました。");
    };
  }

  const getSelectedShopInfoList = () => {
    return shops.filter((shopInfo) => (shopInfo.is_selected));
  }

  const onClickSelectDestination = (event) => {
    setSelectDestinationDrawerOpen(true);
  }

  const closeSelectDestination = (event) => {
    setSelectDestinationDrawerOpen(false);
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false} 
      PaperProps={{
        style:{
          overflowX: "hidden",
        }
      }}
    >
      <Box padding={2} >
        <Box>
          <Grid container alignItems="center">
            <Grid item xs>
              <Typography>メールプレビュー</Typography>
            </Grid>
            <Grid item xs='auto'>
              <Button variant="contained" onClick={onClickSelectDestination}>送信先選択</Button>
            </Grid>
          </Grid>
          
        </Box>
        <Box marginY={1} width="70vw">
          <MailPreviewWithoutMailTo
            mailSubject={mailSubject}
            mailText={mailText}
          />
        </Box>
        <Box marginTop={1}>
          <Grid container  direction="row" spacing={1}>
            <Grid item xs />
            <Grid item xs="auto">
              <Button variant="outlined" onClick={onClose}>戻る</Button>
            </Grid>
            <Grid item xs="auto">
              <Button variant="contained" onClick={onClickSendMailConfirm} disabled={getSelectedShopInfoList().length === 0}>上の内容でメール送信する</Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <SelectDestinationSendingGroupDrawer
        open={selectDestinationDrawerOpen}
        onClose={closeSelectDestination}
        params={{
          shops: shops,
          setShops: setShops,
          customerSendingGroupInfoList: customerSendingGroupInfoList
        }}
      />
    </Dialog>
  )
}

// fax送付dialog
// props ...
//   open = ダイアログを開いていればtrue
//   onClose = ダイアログを閉じるときの処理 (event) => void
//   sendProps = 送信プロパティ
function SendFaxDialog({open, onClose, sendProps}) {

  const [pdfUrl, setPdfUrl] = useState("")

  const [customerSendingGroupInfoList, setCustomerSendingGroupInfoList] = useState([]);
  const [shops, setShops] = useState([]);
  
  const [selectDestinationDrawerOpen, setSelectDestinationDrawerOpen] = useState(false)


  useEffect(() => {
    if (open) {
      setSelectDestinationDrawerOpen(false);
      setShops([]);

      (async () => {
        let selectInfoListRes = await postCustomerSendingGroupSearchInfoListAPI({});
        setCustomerSendingGroupInfoList(selectInfoListRes.customerSendingGroupInfoList);
      })();
    }
  }, [open])
  
  useEffect (() => {
    if (open && !pdfUrl) {
      (async () => {
        const pdfBytes = await createBasePricePDF(sendProps.shippingDate)    
        const file = new Blob([pdfBytes], {type: "application/pdf"});
        setPdfUrl(URL.createObjectURL(file));
      })()
    } else {
      setPdfUrl(null)
    }
  }, [open, sendProps])

  // 上の内容で注文票FAX送信する　を押下時の挙動
  const onClickSendFaxConfirm = async (event) => {
    try {

      let sendFaxPropsList = getSelectedShopInfoList().map((shopInfo) => ({        
        faxFileUrl : pdfUrl,
        faxNumbers : [shopInfo.fax]
      }));

      await sendFax(sendFaxPropsList);

      alert("faxを送付しました。");
      onClose(event);
    } catch (err) {
      console.log(err);
      alert("faxの送付に失敗しました。");
    };
  }

  const getSelectedShopInfoList = () => {
    return shops.filter((shopInfo) => (shopInfo.is_selected));
  }

  const onClickSelectDestination = (event) => {
    setSelectDestinationDrawerOpen(true);
  }

  const closeSelectDestination = (event) => {
    setSelectDestinationDrawerOpen(false);
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      PaperProps={{
        style:{
          overflowX: "hidden"
        }
      }}
    >
      <Box padding={2}>

        <Grid container alignItems="center">
          <Grid item xs>
            <Typography>基本価格表PDFプレビュー</Typography>
          </Grid>
          <Grid item xs='auto'>
            <Button variant="contained" onClick={onClickSelectDestination}>送信先選択</Button>
          </Grid>
        </Grid>
            
        <Box height="calc(100vh - 130px)" marginY={1}>
          <PdfPreview pdfUrl={pdfUrl} />
        </Box>

        <Box MarginTop={1}>
          <Grid container spacing={1}>
            <Grid item xs />
            <Grid item xs="auto">
              <Button variant="outlined" onClick={onClose}>戻る</Button>
            </Grid>
            <Grid item xs="auto">
              <Button
                variant="contained"
                onClick={onClickSendFaxConfirm}
                disabled={getSelectedShopInfoList().length === 0}
              >
                上の内容で基本価格表FAX送信する
              </Button>
            </Grid>   
          </Grid>
        </Box>        
      </Box>

      <SelectDestinationSendingGroupDrawer
        open={selectDestinationDrawerOpen}
        onClose={closeSelectDestination}
        params={{
          shops: shops,
          setShops: setShops,
          customerSendingGroupInfoList: customerSendingGroupInfoList
        }}
      />
    </Dialog>
  )
}

// 基本価格表ページ
export default function BasicPricePage() {

  const location = useLocation();
  var initShippingDate = location.state ? location.state.shippingDate : null;
  const navigate = useNavigate();

  const [tableTabPosition, setTableTabPosition] = useState(1);
  const [basePriceInfoList, setBasePriceInfoList] = useState([]);
  const [dialogMode, setDialogMode] = useState(-1);
  const [sendProps, setSendProps] = useState({
    method: null,
    shippingDate: null
  });
  const [shippingDateInput, setShippingDateInput] = useState({
    date: "",
    initialized: false,
    cleared: false
  });

  useEffect(() => {
    (async () => {

      // 出荷日初期表示
      if (!initShippingDate) {
        let shippingDateRes = await postMarketCalendarSearchNextOpenDateInfoAPI({});
        initShippingDate = shippingDateRes.nextOpenDateInfo.nextOpenDate;
      }      

      setShippingDateInput({
        ...shippingDateInput,
        date: initShippingDate ? initShippingDate : "",
        initialized: true,
      });

      // 基本価格表データ取得
      let res = await postBasePriceSearchInfoListAPI({"basePriceId": 1});
      setBasePriceInfoList(res.basePriceInfoList);
    })()
  }, [])

  const handleChange = (event, tabPos) => {
    setTableTabPosition(tabPos);
  };

  const onClickEditTable = (event) => {
    navigate(
      SYSTEM_PATH_COMPANY + "/basic_price_edit", {
        state: getBasicPriceEditLocationState(shippingDateInput.date)
      });
  }

  const onClickSendMail = (event) => {
    setSendProps({
      method: "mail",
      shippingDate: new Date(shippingDateInput.date)
    });
    setDialogMode(1);
  }

  const onClickSendFax = (event) => {
    setSendProps({
      method: "fax",
      shippingDate: new Date(shippingDateInput.date)
    });
    setDialogMode(2);
  }

  const onCloseAllDialog = (event) => {
    setDialogMode(-1);
  }


  const getErrorMessages = () => {
     let msgs = [];
 
     if (shippingDateInput.initialized && shippingDateInput.date.length === 0) {
       if (shippingDateInput.cleared) {
         msgs.push(MSG_ERR_SHIPPING_DATE_NOT_ENTERED);
       } else {
         msgs.push(MSG_ERR_SHIPPING_DATE_NOT_FOUND);
       }      
     }

     return msgs;
  }

  // 出荷日更新 
  const updateShippingDate = (shippingDate) => {
    setShippingDateInput({
      ...shippingDateInput,
      date: shippingDate,
      cleared: shippingDate.length === 0      
    });
  }

  return (
    <CompanyTitledPage title="基本価格表">

      <ErrorMessageBox messages={getErrorMessages()} />

      <Grid container spacing={2} alignItems="center">
        <Grid item xs>
          <Typography sx={{fontSize: 20, textAlign: "right"}}>
            出荷日 : 
          </Typography>
        </Grid>
        <Grid item xs="auto">
          <DateInput
            value={shippingDateInput.date}
            setValue={updateShippingDate}
          />
        </Grid>
      </Grid>

      <Box marginTop={2} marginBottom={2}>
        <Grid container alignItems='baseline' spacing={2}>
          <Grid item xs>
            <Tabs value={tableTabPosition} onChange={handleChange}>
              <Tab label="蔬菜" value={1} />
              <Tab label="果物" value={2} />
              <Tab label="スポット" value={3} />
            </Tabs>
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained" onClick={onClickEditTable}>編集</Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained" onClick={onClickSendMail}>基本価格表メール送信</Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained" onClick={onClickSendFax}>基本価格表FAX送信</Button>
          </Grid>
        </Grid>
      </Box>
      
      <Box>
        <PriceTableTabContent tabPosition={tableTabPosition} dataList = {basePriceInfoList.filter((data) => data.priceDetailTypeId === tableTabPosition)} />
      </Box>

      <SendMailDialog open={dialogMode === 1} onClose={onCloseAllDialog} sendProps={sendProps} />
      <SendFaxDialog open={dialogMode === 2} onClose={onCloseAllDialog} sendProps={sendProps} />

    </CompanyTitledPage>
  );
}
